import React from 'react';
import './index.scss';
import '../input/index.scss';

import ArrowIcon from '../../../common/icons/arrow-down-slim.svg';

const Dropdown = props => {
    const options = props.options.map((o, i) => (
        <option key={i} value={o.value}>
            {o.label}
        </option>
    ));

    const onChange = value => {
        props.onChange(value);
    };

    return (
        <div className="dropdown">
            <select
                required={props.required ? 'required' : ''}
                value={props.selected}
                onChange={e => onChange(e.target.value)}
            >
                {options}
            </select>
            <ArrowIcon className="arrow-icon" />
        </div>
    );
};

export default Dropdown;
